<template>
	<div v-if="dataLoaded">
		<v-toolbar color="blue lighten-1" class="white--text">
			<v-icon color="white">mail</v-icon>
			<v-toolbar-title>Oferty</v-toolbar-title>
			<v-spacer/>
			<v-toolbar-title>Liczba złożonych ofert: {{offers.length}}</v-toolbar-title>
		</v-toolbar>
		<div class="ma-4">
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs3>
					<div style="display: flex; flex-direction: row; justify-content: space-between">
						<v-subheader>
							<strong>{{getOfferListLabel}}</strong>
						</v-subheader>
						<v-btn flat icon class="mr-5" @click="handleListExpansion">
							<v-icon>{{getOfferListIcon}}</v-icon>
						</v-btn>
					</div>
				</v-flex>
				<v-flex xs6>
					<i v-if="!showOfferList">Lista ukryta</i>
				</v-flex>
			</v-layout>
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs9>
					<v-expand-transition v-if="showOfferList">
						<v-list three-line>
							<template v-for="offer in offers">
								<v-list-tile :key="offer.id" avatar class="list-item">
									<v-list-tile-avatar>
										<v-icon>mail</v-icon>
									</v-list-tile-avatar>
									<v-list-tile-content>
										<v-list-tile-title v-html="offer.offerData.title"
											style="font-size: 14px"></v-list-tile-title>
										<v-list-tile-sub-title
											v-html="offer.mainBidder.polishName"></v-list-tile-sub-title>
										<v-list-tile-action-text
											v-html="'Numer: ' + offer.offerCode"></v-list-tile-action-text>
										<v-list-tile-action-text
											v-html="'Status: ' + getOfferStatus(offer.offerStatus)"></v-list-tile-action-text>
									</v-list-tile-content>
									<v-list-tile-action>
										<egranty-icon-button
											icon="description"
											label="Podgląd"
											for="contest-summary-offers-view-list-preview"
											id="contest-summary-offers-view-list-preview"
											@click="viewOffer(offer.id)"/>
									</v-list-tile-action>
								</v-list-tile>
							</template>
						</v-list>
					</v-expand-transition>
				</v-flex>
			</v-layout>
		</div>
	</div>
</template>

<script>
	import {Offer} from "@/api/generated/Offer";
	import EgrantyIconButton from "../../../../genericComponents/EgrantyIconButton";

	export default {
		name: "ContestSummaryOffersView",
		components: {EgrantyIconButton},

		data () {
			return {
				offers: [],
				showOfferList: false,
				dataLoaded: false
			};
		},

		created () {
			this.getContestSummaryOffersData();
		},

		computed: {
			getOfferListLabel () {
				return this.showOfferList ? 'Ukryj listę' : 'Wyświetl listę';
			},

			getOfferListIcon () {
				return this.showOfferList ? 'keyboard_arrow_up' : 'keyboard_arrow_down';
			}
		},

		methods: {
			getContestSummaryOffersData () {
				Offer.getSubmittedOfferList(this, this.$route.params.id, successResponse => {
						this.offers = successResponse;
						this.dataLoaded = true;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować ofert", errorResponse);
					});
			},

			handleListExpansion () {
				this.showOfferList = !this.showOfferList;
			},

			getOfferStatus (status) {
				switch (status) {
					case "POST_CORRECTION_MAIN":
						return "Oferta oczekuje na potwierdzenie głównego oferenta po poprawce";
					case "POST_CORRECTION_MUTUAL":
						return "Oferta oczekuje na potwierdzenie innych oferentów po poprawce";
					case "SUBMITTED":
						return "Oferta wysłana";
					case "REJECTED":
						return "Oferta odrzucona";
					case "AWAITING_CORRECTION":
						return "Oferta oczekuje na poprawki";
					case "FINANCED":
						return "Oferta finansowana";
					case "NOT_FINANCED":
						return "Oferta niefinansowana";
					case "APPROVED":
						return "Oferta realizowana";
					case "RESERVED":
						return "Oferta rezerwowa";
					default:
						return "-";
				}
			},

			viewOffer (offerId) {
				this.$router.openInNewTab("/view/contest/" + this.$route.params.id + "/offer/" + offerId);
			}
		}
	};
</script>

<style scoped>
	.v-list__tile__title {
		line-height: 30px;
	}
</style>